import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import ProfileImage from "../../../../../../media/images/profileImage.svg";
import MedalStarSVG from "../../../../../../media/images/icons/medal-star";
import Activities from "../Activities";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import StarFillSVG from "../../../../../../media/images/icons/star-fill";
import { blue, yellow } from "@mui/material/colors";

export default function CompanyCard() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderWidth: "1px",
        borderColor: "info.main",
        borderStyle: "solid",
        padding: "4px 8px",
        borderRadius: "10px",
        boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.07)",
      }}
    >
      <Box
        sx={{
          display: "felx",
          flexDirection: "column",
        }}
      >
        <Typography>نام شرکت:</Typography>
        <Typography color={blue[700]}>تعاونی حمل و نقل کالا زرند</Typography>
      </Box>
      <Box
        sx={{
          display: "felx",
          flexDirection: "column",
        }}
      >
        <Typography>نام شرکت:</Typography>
        <Typography color={blue[700]}>تعاونی حمل و نقل کالا زرند</Typography>
      </Box>
    </Box>
  );
}
